import { Controller } from "@hotwired/stimulus"

// Usage: <div data-controller="scroll-into-view" data-scroll-into-view-target="item">
export default class extends Controller {
  static targets = ["item", "flash"]

  static values = {
    flashClass: String,
    afterNavigation: Boolean
  }

  connect() {
    this.handleNavigation = () => this.scrollIntoViewIfNeeded(this.itemTarget)
    if (this.afterNavigationValue) {
      document.addEventListener("turbo:load", this.handleNavigation)
    }

    const el = this.itemTarget
    this.scrollIntoViewIfNeeded(el)
    this.flash(this.hasFlashTarget ? this.flashTarget : el)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.handleNavigation)
  }

  scrollIntoViewIfNeeded(el) {
    if (!this.isFullyVisible(el)) {
      el.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }

  isFullyVisible(el) {
    const rect = el.getBoundingClientRect()
    const viewHeight = window.innerHeight || document.documentElement.clientHeight
    const viewWidth = window.innerWidth || document.documentElement.clientWidth

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= viewHeight &&
      rect.right <= viewWidth
    )
  }

  flash(el) {
    if (!this.hasFlashClassValue) return

    const classes = this.flashClassValue.split(/\s+/) // split on any whitespace
    el.classList.add(...classes) // spread array

    el.addEventListener(
      "animationend",
      () => {
        // console.log("Animation ended, removing flash classes:", classes)
        el.classList.remove(...classes)
      },
      { once: true }
    )
  }

}
